import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const ArtDirection = makeShortcode("ArtDirection");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Titel`}</h1>
    <PageDescription mdxType="PageDescription">
      <p>{`Mit einem Title wird ein ein Inhalt in wenigen Worten zusammengefasst.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Überblick</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Formartierung</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Code</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Referenzen</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Feedback</AnchorLink>
    </AnchorLinks>
    <h2>{`Überblick`}</h2>
    <p>{`Title sind statische Elemente, die den Inhalt in wenigen Worten beschreiben sollen.`}</p>
    <h4>{`Wann zu verwenden`}</h4>
    <p>{`Der Title ist für Bereich mit weiteren detailierten Inhalt zu verwenden oder um eine Überschrift zu setzen.`}</p>
    <h2>{`Formartierung`}</h2>
    <h3>{`Anatomy`}</h3>
    <p>{`Der Titel besteht aus einem Text und aus einer Linie, die den Text unterstreicht.`}</p>
    <ArtDirection mdxType="ArtDirection">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1096px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "36.80555555555556%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAABCcAAAQnAEmzTo0AAABCUlEQVQoz61R20rDQBDt/wsq6LfkqZBLIwgVkfpiLhhDaC6E5h7SJLt73Fnc0id9ceEwZ3aGM7fN+XzGP4DP80z2sFmWBeu6gjGmoDlZinHOFXRc+xTXXOZxEpaih03XdaiqCqfTSYF4WZZomgZ936MoCuR5rv6Ip2mK4/Go8sgnPo4jp+KqQ9d1cH93g93OxXa7hWmasCwLjuPAMAzYto04jhGGIaIogu/78DwPSZIoPwgCKsypYyU4DL0YhlF8hh/i9eVJyMoKdV2LLMtE27YCwK+QY7PLyETo7ffPeHy4VVzvVe9qmia1fLIa1/7VUd5JkEkBJrticfyluEyiihfI5L+w/Fz77RtShROHcL4JxAAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "ArtefactCard anatomy",
          "title": "ArtefactCard anatomy",
          "src": "/static/f0ade30a26f4efd054a27c279bb6a525/40a78/title-anatomy.png",
          "srcSet": ["/static/f0ade30a26f4efd054a27c279bb6a525/7fc1e/title-anatomy.png 288w", "/static/f0ade30a26f4efd054a27c279bb6a525/a5df1/title-anatomy.png 576w", "/static/f0ade30a26f4efd054a27c279bb6a525/40a78/title-anatomy.png 1096w"],
          "sizes": "(max-width: 1096px) 100vw, 1096px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </ArtDirection>
    <ol>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Text`}</strong></p>
      </li>
      <li parentName="ol">
        <p parentName="li"><strong parentName="p">{`Unterstrich`}</strong></p>
      </li>
    </ol>
    <h2>{`Code`}</h2>
    <h3>{`Dokumentation`}</h3>
    <p>{`Das folgende Storybook zeigt den Titel in einer Live Demo. Des Weiteren kann in dieser Testumgebung der mit verschiedenen Texten getestet werden.`}</p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="React Dokumentation" actionIcon="launch" aspectRatio="2:1" href="https://storybook-cranachdesign.netlify.app/?path=/story/atoms-title--template" mdxType="ResourceCard">
  </ResourceCard>
      </Column>
    </Row>
    <h3>{`Code`}</h3>
    <p>{`Titel mit Standardwerten`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javaScript",
        "metastring": "path=CodeSandbox src=https://gatsby-theme-carbon.now.sh",
        "path": "CodeSandbox",
        "src": "https://gatsby-theme-carbon.now.sh"
      }}>{`
<Title />


`}</code></pre>
    <p>{`Beispiel: Titel mit der Übergabe aller möglichen props`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javaScript",
        "metastring": "path=CodeSandbox src=https://gatsby-theme-carbon.now.sh",
        "path": "CodeSandbox",
        "src": "https://gatsby-theme-carbon.now.sh"
      }}>{`
<Title text={'Der neue Titel'}/>

`}</code></pre>
    <h4>{`Props`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Optionen`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`text`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`type your title`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Beschriftung des Titels`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Live Demo`}</h3>
    <h2>{`Feedback`}</h2>
    <p>{`Helfe uns um diese Komponente/Pattern zu verbessern, indem sie Feedback geben, fragen stelle oder andere Kommentare auf `}<a parentName="p" {...{
        "href": "https://github.com/cranach-design-system/cranach-design/issues/new?assignees=&labels=&template=website-feedback.md&title=Website+feedback"
      }}>{`Github`}</a>{` hinterlassen.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      